import type { FC } from 'react';

interface Props {
  className?: string;
}

const SmartLockIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="5" y="11" width="14" height="10" rx="2" strokeWidth="2" />
      <circle cx="12" cy="16" r="1" fill="currentColor" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 11V7a4 4 0 118 0v4"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 13v2" />
    </svg>
  );
};

export default SmartLockIcon;
